import { createFileRoute } from '@tanstack/react-router';

import { UniversityConfigEdit } from '@/module/UniversityConfig/UniversityConfigEdit';

export const Route = createFileRoute('/_auth/administration/_administration/university-config/_university-config/')({
  component: RouteComponent,
});

function RouteComponent() {
  return <UniversityConfigEdit />;
}
